
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

// Retry logic: skip retries on auth/permission errors
function shouldRetryOrdersQuery(failureCount: number, error: any): boolean {
    const status = error?.status;
    if (status === 401 || status === 403) return false;
    return failureCount < 2;
}

// Centralized query keys for easy invalidation
export const orderKeys = {
    all: ['orders'] as const,
    lists: () => [...orderKeys.all, 'list'] as const,
    list: (role: string, userId?: number) => [...orderKeys.lists(), { role, userId }] as const,
};

export { shouldRetryOrdersQuery };

/**
 * Hook to get an invalidation helper for order queries.
 * Used by WebSocket handlers and manual refresh.
 */
export function useInvalidateOrders() {
    const queryClient = useQueryClient();

    const invalidate = useCallback(() => {
        queryClient.invalidateQueries({ queryKey: orderKeys.lists() });
    }, [queryClient]);

    return invalidate;
}
